// gkc_hash_code : 01GPFQ2BY4JCG0W281FKCRX39R
import {
  DATE_FORMAT,
  QUANTITY_INPUT_MAX_LENGTH,
  unitLabelMapper,
} from 'util/ConstantValues';
import { ItemType } from 'util/Types';
import { validateInputEmissionNumber } from 'util/validator';
import styles from './EmissionBatchEditItem.module.scss';
import { mergeClasses } from 'util/commons';
import { Form } from 'react-final-form';
import { SelectField, SelectOption } from '../SelectField';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { selectUser } from 'redux/slices/userSlice';
import { EmissionEditModalEmissionData } from 'components/organisms/EmissionBatchEditModal';
import { getFormatDateWithCurrentTimezone } from 'ts/formatDate';
import UnCollectChainTag from 'components/atoms/UnCollectChainTag';

export type Props = {
  emissionEditData: EmissionEditModalEmissionData;
  onChange: (id: string, field: string, e: string) => void;
  temporaryStorageOptions?: SelectOption[];
  tenantOptions?: SelectOption[];
};

export const EmissionBatchEditItem = ({
  emissionEditData,
  onChange,
  temporaryStorageOptions = [],
  tenantOptions = [],
}: Props) => {
  const { t } = useTranslation();
  const user = useSelector(selectUser);

  const getInputUnit = () => {
    return emissionEditData?.itemType === ItemType.OPTIONAL
      ? 'kg'
      : emissionEditData?.itemType === ItemType.FIX &&
        emissionEditData.unit != null
      ? unitLabelMapper[emissionEditData.unit]
      : '';
  };

  return (
    <Form onSubmit={() => {}}>
      {() => (
        <div className={styles.emissionEditItem}>
          <div
            className={mergeClasses(
              styles.emissionEditItemCol,
              styles.emissionEditItemColName
            )}
          >
            <p className={styles.itemName}>
              {emissionEditData.item}{' '}
              {emissionEditData?.itemType === ItemType.FIX
                ? `${emissionEditData.convertKg}kg/1${getInputUnit()}`
                : ''}
            </p>

            <UnCollectChainTag
              collectionOperatorName={emissionEditData.collectUserName}
              emissionStatus={emissionEditData.emissionStatus}
            />
          </div>

          <div className={styles.emissionEditItemCol}>
            <p className={styles.itemName}>
              {getFormatDateWithCurrentTimezone(
                emissionEditData.datetime,
                DATE_FORMAT.slaYMDHm
              )}
            </p>
          </div>

          <div className={styles.emissionEditItemCol}>
            <SelectField
              name="tenantId"
              wrapperClassName={styles.selectWrapper}
              value={emissionEditData.tenantId?.toString() || '-1'}
              options={tenantOptions}
              onChange={(value) => {
                onChange(
                  emissionEditData.id,
                  'tenantId',
                  value === '-1' ? '' : String(value)
                );
              }}
              searchable
              isDarkmode
              usePortal
            />
          </div>

          {user.temporaryStorageEnabled && (
            <div
              className={mergeClasses(
                styles.emissionEditItemCol,
                styles.emissionEditItemColTempStorage
              )}
            >
              <SelectField
                name="temporaryStorageId"
                wrapperClassName={styles.selectWrapper}
                value={emissionEditData.temporaryStorage?.id?.toString() ?? ''}
                placeholder={t('emission_qr_scanning.temporary_storage')}
                options={temporaryStorageOptions}
                onChange={(value) => {
                  onChange(
                    emissionEditData.id,
                    'temporaryStorageId',
                    String(value)
                  );
                }}
                isDarkmode
                usePortal
                searchable
              />
            </div>
          )}

          <div
            className={mergeClasses(
              styles.emissionEditItemCol,
              styles.emissionEditItemColInput
            )}
          >
            <div className={styles.inputWrapper}>
              <input
                lang="en"
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                onInput={(e: any) => e.target.value.replace(/[^0-9]*/g, '')}
                maxLength={QUANTITY_INPUT_MAX_LENGTH}
                className={styles.input}
                type="text"
                onChange={(e) => {
                  if (
                    e.target.value === '' ||
                    e.target.value == '0' ||
                    !validateInputEmissionNumber(
                      e.target.value,
                      emissionEditData?.itemType as ItemType
                    )
                  ) {
                    onChange(emissionEditData.id, 'wasteUnit', e.target.value);
                  }
                }}
                value={
                  emissionEditData?.itemType === ItemType.OPTIONAL
                    ? emissionEditData?.weight || ''
                    : emissionEditData?.quantity || ''
                }
              />
              <span className={styles.unit}>{getInputUnit() || ''}</span>
            </div>
          </div>
        </div>
      )}
    </Form>
  );
};
